export enum CocoUserTitle {
    StationManager = "Station Manager",
    AssistantStationManager = "Assistant Station Manager"
}
